import { render, staticRenderFns } from "./ListTaxiType.vue?vue&type=template&id=b1780df6&"
import script from "./ListTaxiType.vue?vue&type=script&lang=js&"
export * from "./ListTaxiType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports